/**
 * Replacer Utility override
 */

define(function(require) {
    const replacerUtil = require('util/replacer.util');
    const replacers = [
        require('replacers/parx-theme/forgotpassword/forgotpassword.view')
    ];

    return {
        ...replacerUtil,

        init: function() {
            replacerUtil.init();
            replacers.forEach(this.register.bind(this));
        }
    };

});
